import { IState } from 'shared/store';

export const selectNewbuildingSuburbanTrapUrl = (state: IState): string | undefined => {
  return state.offerData.newbuildingFlatSaleQueryString;
};
